exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guide[data-v-cbd7ae66]{display:inline-block;position:relative}.guide-content[data-v-cbd7ae66]{padding:10px;background-color:#0a64fa;position:absolute;left:0}.rec[data-v-cbd7ae66]{position:absolute;content:\"\";display:block;width:0;height:0;border:8px solid #0a64fa;bottom:-8px;transform:rotate(45deg)}.guide-text[data-v-cbd7ae66]{color:#fff;display:block;line-height:24px;font-size:14px}", ""]);

// exports
